/* tslint:disable */
/* eslint-disable */
/**
 * Aerscape API
 * Aerscape API documentation (internal).
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SSORequiredCheckRequest
 */
export interface SSORequiredCheckRequest {
    /**
     * 
     * @type {string}
     * @memberof SSORequiredCheckRequest
     */
    email: string;
    /**
     * 
     * @type {string}
     * @memberof SSORequiredCheckRequest
     */
    next?: string;
}

/**
 * Check if a given object implements the SSORequiredCheckRequest interface.
 */
export function instanceOfSSORequiredCheckRequest(value: object): value is SSORequiredCheckRequest {
    if (!('email' in value) || value['email'] === undefined) return false;
    return true;
}

export function SSORequiredCheckRequestFromJSON(json: any): SSORequiredCheckRequest {
    return SSORequiredCheckRequestFromJSONTyped(json, false);
}

export function SSORequiredCheckRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): SSORequiredCheckRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'email': json['email'],
        'next': json['next'] == null ? undefined : json['next'],
    };
}

export function SSORequiredCheckRequestToJSON(json: any): SSORequiredCheckRequest {
    return SSORequiredCheckRequestToJSONTyped(json, false);
}

export function SSORequiredCheckRequestToJSONTyped(value?: SSORequiredCheckRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'email': value['email'],
        'next': value['next'],
    };
}

